import React, { useContext } from 'react';
import 'src/assets/styles/react-table.scss';
import TPESelectableReactTable from 'src/components/shared/TPESelectableReactTable';
import { MECStatusContext } from './StatusView';
import CONSTANTS from 'src/utils/constants';
import ExecutionStatusIndicator from "src/components/mec/status/ExecutionStatusIndicator";
import {ACTIONS} from "src/services/mec/status/MECStatusReducer";
import {Reversal} from "src/models/mec/status/Reversal";

export default function CLIDetailsGrid(props: {loading: boolean, onCLISelect: () => any}) {
    const { loading , onCLISelect} = props;
    const { state, dispatch } = useContext(MECStatusContext);
    const { cliDetailsResult } = state;

    const getColDefs = () => {
        const colDefs: any[] = [];
        CONSTANTS.MEC_CLI_DETAILS_COLUMN_HEADERS.forEach(column => {
            if(column.ACCESSOR == CONSTANTS.MEC_CLI_DETAILS_COLUMN_HEADERS[1].ACCESSOR){
                colDefs.push({
                    Header: (e: any) => <div className="cell-text">{column.DISPLAY}</div>,
                    accessor: column.ACCESSOR,
                    Cell: (e: any) => <div className="cell-text"><ExecutionStatusIndicator status={e.value} /></div>
                })
            }else{
                colDefs.push({
                    Header: (e: any) => <div className="cell-text">{column.DISPLAY}</div>,
                    accessor: column.ACCESSOR
                });
            }
        });
        return colDefs;
    }

    return (
        <div className="mecGrid">
            {cliDetailsResult && <TPESelectableReactTable {...{
                data: cliDetailsResult.cliDetails,
                columnDefinitions: getColDefs(),
                className: "mecCLIDetailsGrid",
                isSearching: loading,
                editableOptions: null as unknown as any,
                allowMultipleRowSelection: true,
                onRowClicked:(isChecked, reversal: Reversal, index) =>  onCLISelect()
            }} />}
        </div>
    );
}